module.exports = __webpack_public_path__ + "img/256.cf79304b.png";